/* @ngInject */
function AssetPackItemsViewController ($scope, $q, $translate, $timeout, $state, GuestSummaryService, ToastService, AssetPackService, Utils, RepositoryService, SegmentService, UdsModalService) {
  const getGuestAssetPackDownloadSuccessDialogController = () => import('../../dialogs/guest-asset-pack-download-success/guest-asset-pack-download-success.controller')

  $scope.assetPackId = $state.params.assetPackId
  $scope.assetFolderId = $state.params.assetFolderId

  $scope.assets = {
    rows: [],
    count: 0
  }
  $scope.assetFolders = {
    rows: [],
    count: 0,
    isFirstRequest: true
  }
  $scope.pagination = {
    assets: {
      skip: 0,
      take: 20
    },
    assetFolders: {
      skip: 0,
      take: 20
    }
  }
  $scope.flags = {
    loading: true,
    loadingMore: false,
    showAssets: false
  }
  $scope.selectedAssets = []
  $scope.selectedAssetFolders = []
  $scope.breadcrumbs = {
    show: false,
    history: [],
    items: [],
    current: null,
    root: { id: null, title: '' },
    onChange: (event) => {
      const id = event.originalEvent.detail?.id

      if (id === parseInt($scope.assetFolderId, 10)) return

      if (id === null) { // Root
        $state.go('assetPack.assetPackSummary', { assetPackId: $scope.assetPackId })
      } else {
        $state.go('assetPack.assetPackFolder', { assetPackId: $scope.assetPackId, assetFolderId: id })
      }
    }
  }

  $scope.emptyStateTitleKey = ''
  $scope.emptyStateMessageKey = ''

  const api = {
    getGuestAssetPackDownloadSuccessDialogController,
    _loadAssetPackSummaryData,
    _getAssetPackFiles,
    _getAssetFolders,
    _requestAssetFolders,
    _getAssets,
    _requestAssets,
    _getBreadcrumbs,
    _formatBreadcrumbs,
    _handleError,
    _setEmptyStateKeys,
    _openGuestAssetPackDownloadSuccessDialog
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._setEmptyStateKeys()
    api._loadAssetPackSummaryData()
  }

  function _loadAssetPackSummaryData () {
    AssetPackService.getAssetPackSummaryData($scope.assetPackId).then((assetPackData) => {
      $scope.assetPack = assetPackData

      api._getAssetPackFiles().then(() => {
        const insideFolder = !!$scope.assetFolderId
        const hasItems = !!$scope.assetFolders.rows.length || !!$scope.assets.rows.length
        const enableDownloadAll = insideFolder || hasItems

        AssetPackService.callEnableDownloadAllButtonListener(enableDownloadAll)
      })

      if ($scope.assetFolderId) {
        $scope.breadcrumbs.root.title = $scope.assetPack.title
        api._getBreadcrumbs()
      }
    }).catch((error) => {
      $timeout(() => {
        $scope.flags.loading = false
      })

      api._handleError(error)
    })
  }

  function _handleError (error) {
    if (error.data?.code === 'EXPIRED') {
      $scope.emptyStateTitleKey = 'guest.expiredState.title'
      $scope.emptyStateMessageKey = 'guest.expiredState.description'
    } else if (error.data?.code === 'NOT_FOUND') {
      $scope.emptyStateTitleKey = 'guest.notFoundState.title'
      $scope.emptyStateMessageKey = 'guest.notFoundState.description'
    } else {
      console.error(error)
      ToastService.defaultErrorToast()
    }
  }

  async function _getAssetPackFiles () {
    if (!$scope.assetPackId) {
      $scope.flags.loading = false
      $scope.flags.loadingMore = false
      api._handleError({ data: { code: 'NOT_FOUND', message: 'Asset pack not found' } })
    }

    if ($scope.assetFolders.isFirstRequest || $scope.assetFolders.rows.length < $scope.assetFolders.count) {
      return api._getAssetFolders()
    }
    return api._getAssets()
  }

  function _getAssetFolders () {
    return api._requestAssetFolders()
      .then((assetFolders) => {
        let assetsPromise

        if ($scope.assetFolders.isFirstRequest) {
          $scope.assetFolders.isFirstRequest = false
          assetsPromise = api._getAssets() // Get assets count at the first request.
        } else {
          $timeout(() => {
            $scope.flags.loading = false
            $scope.flags.loadingMore = false
          })
        }

        $scope.assetFolders.rows.push(...(assetFolders.rows ?? []))
        $scope.assetFolders.count = assetFolders.count

        $scope.pagination.assetFolders.skip += ($scope.pagination.assetFolders.take ?? assetFolders.count)

        if ($scope.assetFolders.rows.length === $scope.assetFolders.count) {
          $scope.flags.showAssets = true
        }

        if (assetsPromise) {
          return assetsPromise
        }
      })
      .catch(api._handleError)
  }

  function _requestAssetFolders () {
    const defaultParams = {
      top: $scope.pagination.assetFolders.take,
      skip: $scope.pagination.assetFolders.skip,
      assetPackId: $scope.assetPackId
    }

    if ($scope.assetFolderId) {
      return GuestSummaryService.getAssetFoldersByFolderId({
        ...defaultParams,
        folderId: $scope.assetFolderId
      })
    }

    return GuestSummaryService.getAssetFoldersByAssetPackId({
      ...defaultParams
    })
  }

  function _getAssets () {
    return api._requestAssets()
      .then((assets) => {
        $scope.assets.rows.push(...(assets.rows ?? []))
        $scope.assets.count = assets.count

        $scope.pagination.assets.skip += ($scope.pagination.assets.take ?? assets.count)
      })
      .catch(api._handleError)
      .finally(() => {
        $timeout(() => {
          $scope.flags.loading = false
          $scope.flags.loadingMore = false
        })
      })
  }

  function _requestAssets () {
    const defaultParams = {
      top: $scope.pagination.assets.take,
      skip: $scope.pagination.assets.skip,
      assetPackId: $scope.assetPackId
    }

    if ($scope.assetFolderId) {
      return GuestSummaryService.getAssetsByFolderId({
        ...defaultParams,
        folderId: $scope.assetFolderId
      })
    }

    return GuestSummaryService.getAssetsByAssetPackId({
      ...defaultParams
    })
  }

  function _getBreadcrumbs () {
    GuestSummaryService.getFolderPath($scope.assetPackId, $scope.assetFolderId)
      .then((folderPath) => {
        $scope.breadcrumbs.history = [...folderPath]
        $scope.breadcrumbs.history.unshift($scope.breadcrumbs.root)
        api._formatBreadcrumbs()
        $scope.breadcrumbs.show = true
      })
  }

  function _formatBreadcrumbs () {
    $scope.breadcrumbs.items = $scope.breadcrumbs.history.map(item => {
      return {
        ...item,
        label: item.title
      }
    })
  }

  function _setEmptyStateKeys () {
    if ($scope.assetFolderId) {
      $scope.emptyStateTitleKey = 'emptyFolderUser'
      $scope.emptyStateMessageKey = 'emptyFolderUserDesc'
    } else {
      $scope.emptyStateTitleKey = 'guest.assetPacksEmptyTitle'
      $scope.emptyStateMessageKey = 'guest.assetPacksEmptyTextArchived'
    }
  }

  function _openGuestAssetPackDownloadSuccessDialog () {
    api.getGuestAssetPackDownloadSuccessDialogController().then(({ GuestAssetPackDownloadSuccessDialogController }) => {
      const guestAssetPackDownloadSuccessDialog = UdsModalService.createModal({
        controller: GuestAssetPackDownloadSuccessDialogController,
        modalName: 'guestAssetPackDownloadSuccessDialog',
        data: {}
      })

      guestAssetPackDownloadSuccessDialog.open()
    })
  }

  $scope.isLoadMoreAvailable = () => {
    return ($scope.assetFolders.count > 0 && $scope.assetFolders.rows.length < $scope.assetFolders.count) ||
      ($scope.assets.count > 0 && $scope.assets.rows.length < $scope.assets.count)
  }

  $scope.handleLoadMore = () => {
    if ($scope.flags.loadingMore) return
    $scope.flags.loadingMore = true
    api._getAssetPackFiles()
  }

  $scope.handleSelectAssetFolder = (id) => {
    const index = $scope.selectedAssetFolders.indexOf(id)
    if (index === -1) {
      $scope.selectedAssetFolders.push(id)
    } else {
      $scope.selectedAssetFolders.splice(index, 1)
    }
  }

  $scope.handleSelectAsset = (id) => {
    const index = $scope.selectedAssets.indexOf(id)
    if (index === -1) {
      $scope.selectedAssets.push(id)
    } else {
      $scope.selectedAssets.splice(index, 1)
    }
  }

  $scope.handleDownloadSelectedAssetsAndFolders = () => {
    if (!$scope.selectedAssets?.length && !$scope.selectedAssetFolders?.length) return

    AssetPackService.downloadAssetFoldersAndAssetsBatch({
      assetIds: $scope.selectedAssets,
      assetPackId: $scope.assetPackId,
      assetFolderIds: $scope.selectedAssetFolders
    }).then((response) => {
      api._openGuestAssetPackDownloadSuccessDialog()

      $scope.selectedAssetFolders.forEach(id => {
        SegmentService.track('downloaded-file', {
          asset_pack_id: $scope.assetPackId,
          folder_id: id
        })
      })
      $scope.selectedAssets.forEach(id => {
        SegmentService.track('downloaded-file', {
          asset_pack_id: $scope.assetPackId,
          asset_id: id
        })
      })
    }).catch(() => {
      ToastService.showErrorToast($translate.instant('assetFolder.toasts.downloadAssets.error'))
    })
  }

  $scope.isAssetSelected = (id) => {
    return $scope.selectedAssets.includes(id)
  }

  $scope.isAssetFolderSelected = (id) => {
    return $scope.selectedAssetFolders.includes(id)
  }

  $scope.isAssetOrAssetFolderSelected = () => {
    return $scope.selectedAssetFolders?.length + $scope.selectedAssets?.length > 0
  }
}

export { AssetPackItemsViewController }
